import { api } from '@services';

export interface ManufacturerNameAndId {
  name: string;
  model: string;
  id: string;
}
export interface IGetProductsAutocompleteRequest {
  search: string;
  manufacturerId?: string;
}
const getProductsAutocomplete = async ({
  search,
  manufacturerId,
}: IGetProductsAutocompleteRequest): Promise<ManufacturerNameAndId[]> => {
  const { data: productsSuggestions } = await api.get<ManufacturerNameAndId[]>(
    `/products/autocomplete?search=${encodeURIComponent(search)}${
      manufacturerId ? `&manufacturerId=${manufacturerId}` : ''
    }`,
  );

  return productsSuggestions;
};

export { getProductsAutocomplete };
